<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>ShipTo Distribuidores</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>ShipTo Distribuidor</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-form-field  *ngIf="idTipo == 1" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Cliente}}</mat-label>
                        <input (change)="handleEmptyInputCliente($event)" matInput [matAutocomplete]="autoC"
                            [formControl]="fcAutocompleteCliente" placeholder="Nro. cliente, nombre, etc...">
                        <button type="button" matSuffix mat-icon-button matTooltip="Limpiar cliente seleccionado"
                            (click)="limpiarCliente(true)">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-autocomplete #autoC="matAutocomplete"
                            (optionSelected)='seleccionarCliente($event.option.value)'
                            [displayWith]="getOptionTextCliente">
                            <mat-option *ngIf="loadingFcAutocompleteCliente" class="is-loading">Cargando...</mat-option>
                            <ng-container *ngIf="!loadingFcAutocompleteCliente">
                                <mat-option *ngFor="let cl of clientesEncontrados" [value]="cl">
                                    {{cl.displayValue}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>

                    </mat-form-field>

                    <mat-form-field  *ngIf="idTipo != 1" class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NombreCliente}}</mat-label>
                        <input readonly [value]="d.shipToData.nombre" type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.DireccionEntrega}}</mat-label>
                        <mat-select (selectionChange)='seleccionarDirEntrega($event.value)'
                            [compareWith]="compareDireccionEntrega" formControlName="shipTo">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let de of dirEntregas" [value]="de.nroCliente">{{de.displayValue}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="(form.get('shipTo').hasError('required')) && form.get('shipTo').touched">
                            {{Validaciones.DireccionEntrega}}
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="idTipo == 1" color="accent-darker"
                        appearance="outline">
                        <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                        <mat-select [compareWith]="compareCuentasDistribuidores"
                            formControlName="nroClienteDistribuidor"
                            (selectionChange)='seleccionarCuentaDistribuidor($event.value)'>
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let d of cuentasDistribuidores"
                                [value]="d.nroClienteCuenta">{{d.nombre}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(form.get('nroClienteDistribuidor').hasError('required')) && form.get('nroClienteDistribuidor').touched">
                            {{Validaciones.NroClienteDistribuidor}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="idTipo != 1" class="readonly-form-field" color="accent-darker"
                        appearance="outline">
                        <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                        <input readonly [value]="d.sucDistribuidorData.nombre" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>Sucursal Distribuidor</mat-label>
                        <mat-select [compareWith]="compareDirecciones" formControlName="sucDistribuidor"
                            (selectionChange)='seleccionarDireccion($event.value)'>
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let di of direcciones" [value]="di.nroCliente">{{di.displayValue}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('sucDistribuidor').hasError('required')) && form.get('sucDistribuidor').touched">
                            {{Validaciones.IdSucursal}}
                        </mat-error>
                    </mat-form-field>

                </div>

            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="guardarShipToDistribuidor()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>

</mat-dialog-actions>